import { createEventConstants, authConstants } from '../constants';
import { MessagesActions } from './';
import { CreateEventApi } from '../services';
import { redirect } from '../helper';

export class CreateEventActions {
    static create (data) {
        return (dispatch) => {
            dispatch({type: createEventConstants.CREATE_EVENT_REQUEST, payload: {...data}});

            CreateEventApi.create(data)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success 
                    if(res.meta.success === true) {
                        dispatch({type: createEventConstants.CREATE_EVENT_SUCCESS, payload: {...res.data}});
                        dispatch(MessagesActions.pushSuccess(`האירוע ${data.name} נוצר בהצלחה`)); // be careful from xss attack
                        redirect(`./${res.data.eventID}/settings`); // redirect to event settings page
                        return;
                    }

                    dispatch(MessagesActions.pushError('יצירת האירוע נכשלה אנא נסו שוב'));
                    return dispatch({type: createEventConstants.CREATE_EVENT_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: createEventConstants.CREATE_EVENT_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/createEvent.js